import { CommonHelperFunctions, IDomainDto, IDomainWideProjectRole } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class DomainService {
  public static async Create(obj: IDomainDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IDomainDto, AxiosResponse>(`${backendUrl}/domains/create`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async UpdateDomainAuthorization(domainName: string, isAuthEnabled: boolean): Promise<AxiosResponse> {
    try {
      return await Axios.put<any, AxiosResponse>(`${backendUrl}/domains/${domainName}/authorization`, {
        domainAuthorizationOn: isAuthEnabled
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetDomainDetail(domainName: string): Promise<AxiosResponse> {
    try {
      return await Axios.get<any, AxiosResponse>(`${backendUrl}/domains/${domainName}`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetCurrentDomainDetail(): Promise<AxiosResponse<any>> {
    try {
      return await Axios.get(`${backendUrl}/domains/current-domain-detail`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetDomainWideProjectRoles(domainId: string): Promise<AxiosResponse<IDomainWideProjectRole[]>> {
    try {
      return await Axios.get<null, AxiosResponse<IDomainWideProjectRole[]>>(`${backendUrl}/domains/${domainId}/roles`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  // Workspace role registry (KOA-18634): rename an app role across every project in the current
  // domain that uses it. Ids are kept, so generated apps rename in place on their next deploy.
  public static async RenameWorkspaceRole(oldName: string, newName: string): Promise<AxiosResponse> {
    try {
      return await Axios.post<null, AxiosResponse>(`${backendUrl}/domains/app-roles/rename`, {
        oldName,
        newName
      });
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
